import store from '../store'

export default (to, from, next) => {
  if (store.getters.user && store.getters.user.organisation) {
    next()
  } else {
    if (store.getters.user) {
      next({
        name: 'HelloWorld'
      })
    } else {
      next({
        name: 'Login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  }
}
